module.exports = __webpack_public_path__ + "static/media/icons8-share.718abb07.svg";